import { Banners, UserId } from '@raysee/domain';
import { BannerGateway } from '../gateway/bannerGateway';
import { SubscriptionGateway } from '../gateway/subscriptionGateway';

export class BannerUsecase {
  private bannerGateway = new BannerGateway();
  private subscriptionGateway = new SubscriptionGateway();

  getTopPageBannersForGuest = async (): Promise<Banners> =>
    await this.bannerGateway.getBannersForGuestUser();

  getTopPageBannersForAuthUser = async (userId: UserId): Promise<Banners> => {
    const [banners, subscriptions] = await Promise.all([
      this.bannerGateway.getBannersForAuthUser(),
      this.subscriptionGateway.getSubscWithMenuListByUserId(userId),
    ]);
    return Banners.filterBySubscRetargetAttribute(banners, subscriptions);
  };
}
